import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { GenericStore } from '@app/stores/generic.store';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { NameFormComponent } from '../name-form/name-form.component';
import { TitleNameFormGroup } from './title-name-form.helper';

@Component({
  selector: 'app-title-name-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidatedDropdownComponent,
    GetLocalizedPipe,
    NameFormComponent,
  ],
  templateUrl: './title-name-form.component.html',
  styleUrl: './title-name-form.component.scss',
})
export class TitleNameFormComponent {
  genericDataStore = inject(GenericStore);
  formGroup = input.required<FormGroup<TitleNameFormGroup>>();
  showTitle = input<boolean>(false);
  disabled = input<boolean>(false);
}
